// Icons served from /public/icons/ — SVG for crisp rendering at all sizes
const base = '/icons'

export const NAV_ICONS: Record<string, string> = {
  admin_person:   `${base}/admin_person.svg`,
  ai_robot:       `${base}/ai_robot.svg`,
  alerts_bell:    `${base}/alerts_bell.svg`,
  analyze:        `${base}/analyze.svg`,
  dashboard:      `${base}/dashboard.svg`,
  dca_calc:       `${base}/dca_calc.svg`,
  dca_clock:      `${base}/dca_clock.svg`,
  earnings:       `${base}/earnings.svg`,
  insider:        `${base}/insider.svg`,
  intel:          `${base}/intel.svg`,
  journal:        `${base}/journal.svg`,
  macro:          `${base}/macro.svg`,
  notes:          `${base}/notes.svg`,
  options:        `${base}/options.svg`,
  scanner:        `${base}/scanner.svg`,
  settings:       `${base}/settings.svg`,
  short_interest: `${base}/short_interest.svg`,
  trading:        `${base}/trading.svg`,
  trading2:       `${base}/trading2.svg`,
  watchlist:      `${base}/watchlist.svg`,
  volume_surge:   `${base}/volume_surge.svg`,
}
